export const view = "/view/add-view";
export const getReviewsById = "/review/car";
export const getAverageReviewsById = "/review/average";
export const addReview = "/review/add";